const initialState = {
  list: [
    {
      _id: '1',
      title: 'Padrão',
      scale: 'colors',
      grade: '#606060',
      button: '#7da38b',
      body: `<p>Obrigado por escolher a nossa empresa.</p>
  <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
    questionário que dura apenas 60 segundos.
  </p>
  <p>Agradecemos a sua colaboração.<br />`,
    },
    {
      _id: '2',
      title: 'Custom',
      scale: 'custom',
      grade: '#606060',
      button: '#7da38b',
      body: `<p>Obrigado por escolher a nossa empresa.</p>
  <p>Gostaríamos de aperfeiçoar a sua experiência com os nossos serviços através deste
    questionário que dura apenas 60 segundos.
  </p>
  <p>Agradecemos a sua colaboração.<br />`,
    },
  ],
  templateSelected: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/templates/initialState.js